import { ImageLoaderProps } from 'next/image';
import { DOMAIN, IMAGE_RESIZER_URL } from 'src/env';

type ResolverProps = Omit<ImageLoaderProps, 'config' | 'width'> & {
  width?: ImageLoaderProps['width'];
  format?: 'avif' | 'webp' | 'auto';
};

type GetOptimizedImage = (resolverProps: ResolverProps) => string;

export const getOptimizedImage: GetOptimizedImage = ({ src, width = 1080, quality = 75 }) => {
  const params = `${encodeURIComponent(src)}&w=${width}&q=${quality}`;

  return `${DOMAIN}/_next/image?url=${params}`;
};

export const imageLoader = ({ src, width = 1080, quality = 75, format = 'auto' }: ResolverProps) => {
  if (src.includes('/_next/')) return src;
  if (!src.includes('static.platzi.com') && !src.includes('platzistaging.s3.amazonaws.com'))
    return getOptimizedImage({ src, width, quality });

  const url = new URL(src);
  const { pathname } = url;

  const params = `cdn-cgi/image/width=${width},quality=${quality},format=${format}`;
  return `${IMAGE_RESIZER_URL}/${params}${pathname}`;
};
